import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import SiteHead from './components/SiteHead';
import Footer from './components/Footer';
import BottomNav from './components/BottomNav';
import AgeGate from './components/AgeGate';
import PWAInstall from './components/PWAInstall';
import WelcomePopup from './components/WelcomePopup';
import HomePage from './pages/HomePage';
import CatalogPage from './pages/CatalogPage';
import CartPage from './pages/CartPage';
import OrdersPage from './pages/OrdersPage';
import PromotionsPage from './pages/PromotionsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import AdminPage from './pages/admin/AdminPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import RegistroPage from './pages/RegistroPage';
import InicioSesionPage from './pages/InicioSesionPage';
import ProfilePage from './pages/ProfilePage';
import FAQPage from './pages/FAQPage';
import PagosPage from './pages/PagosPage';
import EnviosPage from './pages/EnviosPage';
import ContactoPage from './pages/ContactoPage';
import TerminosPage from './pages/TerminosPage';
import RecuperarPage from './pages/RecuperarPage';
import RestablecerPage from './pages/RestablecerPage';
import ComoInstalarPage from './pages/ComoInstalarPage';
import PrivacidadPage from './pages/PrivacidadPage';
import PaymentResultPage from './pages/PaymentResultPage';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { Toaster } from './components/ui/toaster';
import WhatsAppButton from './components/WhatsAppButton';
import CookieBanner from './components/CookieBanner';

function AppShell({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  return (
    <>
      <Header />
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <BottomNav />}
      <AgeGate />
      {!isAdmin && <PWAInstall />}
      {!isAdmin && <WelcomePopup />}
      {!isAdmin && <WhatsAppButton />}
      {!isAdmin && <CookieBanner />}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-black text-white">
      <BrowserRouter>
        <ScrollToTop />
        <SiteHead />
        <AuthProvider>
          <CartProvider>
            <AppShell>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/catalogo" element={<CatalogPage />} />
                <Route path="/producto/:handle" element={<ProductDetailPage />} />
                <Route path="/carrito" element={<CartPage />} />
                <Route path="/pedidos" element={<OrdersPage />} />
                <Route path="/promociones" element={<PromotionsPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/registro" element={<RegistroPage />} />
                <Route path="/inicio-sesion" element={<InicioSesionPage />} />
                <Route path="/perfil" element={<ProfilePage />} />
                <Route path="/preguntas-frecuentes" element={<FAQPage />} />
                <Route path="/formas-de-pago" element={<PagosPage />} />
                <Route path="/envios-y-devoluciones" element={<EnviosPage />} />
                <Route path="/contacto" element={<ContactoPage />} />
                <Route path="/terminos-del-servicio" element={<TerminosPage />} />
                <Route path="/aviso-de-privacidad" element={<PrivacidadPage />} />
                <Route path="/recuperar-contrasena" element={<RecuperarPage />} />
                <Route path="/restablecer-contrasena" element={<RestablecerPage />} />
                <Route path="/como-instalar" element={<ComoInstalarPage />} />
                <Route path="/auth/callback" element={<AuthCallbackPage />} />
                <Route path="/payment/success" element={<PaymentResultPage />} />
                <Route path="/payment/failure" element={<PaymentResultPage />} />
                <Route path="/payment/pending" element={<PaymentResultPage />} />
                <Route path="*" element={<HomePage />} />
              </Routes>
            </AppShell>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
